export default __webpack_public_path__ + "2054252.png";